<template>
  <div class="page-commercial-products-ipr">
    <tabbed-view :tabs="getTabs()"></tabbed-view>
  </div>
</template>

<script>
import IprProductCompanyTypeMixin from "@/components/mixins/IprProductCompanyTypeMixin";
import TabbedView from '@/views/components/tabs/TabbedView';
import {mapGetters} from 'vuex';

export default {
name: "CommercialProduct",
  components: {
    TabbedView,
  },
  mixins: [IprProductCompanyTypeMixin],
  computed: {
    ...mapGetters({
      isDeleted: 'getIsDeleted'
    })
  },
  methods: {
    getTabs() {
      return [
        {
          label: 'Commercial Product IPR Details',
          route: `${this.ProductCompanyType}.commercial-products-ipr.view`,
        },
        {
          label: 'Assigned Producers',
          route: `${this.ProductCompanyType}.commercial-products-ipr.producers.view`,
          hideIfDeleted: this.isDeleted,
        },
        {
          label: 'Alternative Commercial Products',
          route: `${this.ProductCompanyType}.commercial-products-ipr.alternative-commercial-products.view`,
          hideIfDeleted: this.isDeleted,
        },
        {
          label: 'Extra Info',
          route: `${this.ProductCompanyType}.commercial-products-ipr.extra-info.view`,
          hideIfDeleted: this.isDeleted,
        },
      ]
    }
  },
}
</script>

<style scoped>

</style>
